(() => {
  function slugify(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function replaceNode(node, tagName, text) {
    const replacement = document.createElement(tagName);
    replacement.textContent = text;
    node.replaceWith(replacement);
    return replacement;
  }

  function normalizeInlineLists(container) {
    let activeList = null;
    let activeType = null;
    let node = container.firstElementChild;

    while (node) {
      const next = node.nextElementSibling;
      const tagName = node.tagName.toLowerCase();
      const text = (node.textContent || "").replace(/\s+/g, " ").trim();

      if (tagName === "meta") {
        node.remove();
        node = next;
        continue;
      }

      if (!text && !node.querySelector("img, iframe, video")) {
        node.remove();
        node = next;
        continue;
      }

      if (tagName === "ul" || tagName === "ol") {
        node.classList.add("guide-editorial__list");
        if (tagName === "ol") node.classList.add("guide-editorial__list--ordered");
        activeList = null;
        activeType = null;
        node = next;
        continue;
      }

      if (tagName === "p") {
        const textLines = text
          .split(/\n+/)
          .map((line) => line.trim())
          .filter(Boolean);
        const numberedLines =
          text.match(/\d+\.\s/g) && text.match(/\d+\.\s/g).length > 1
            ? text.split(/(?=\d+\.\s)/).map((line) => line.trim()).filter(Boolean)
            : null;
        const hasImage = node.querySelector("img");

        if (hasImage) {
          const figure = document.createElement("figure");
          const image = node.querySelector("img");
          const captionText = text.replace(/\s+/g, " ").trim();

          figure.className = "guide-editorial__figure";
          if (image) {
            image.remove();
            figure.appendChild(image);
          }

          if (captionText) {
            const figcaption = document.createElement("figcaption");
            figcaption.textContent = captionText;
            figure.appendChild(figcaption);
          }

          node.replaceWith(figure);
          activeList = null;
          activeType = null;
          node = next;
          continue;
        }

        if (numberedLines && numberedLines.length > 1) {
          const list = document.createElement("ol");
          list.className = "guide-editorial__list guide-editorial__list--ordered";
          numberedLines.forEach((line) => {
            const item = document.createElement("li");
            item.textContent = line.replace(/^\d+\.\s*/, "");
            list.appendChild(item);
          });
          node.replaceWith(list);
          activeList = null;
          activeType = null;
          node = next;
          continue;
        }

        const headingLike =
          (text.endsWith(":") && text.split(" ").length <= 8) ||
          ((node.querySelector("strong, b, u") || text === text.toUpperCase()) &&
            text.length <= 80 &&
            !/[.!?]$/.test(text) &&
            !/^[-*•]/.test(text) &&
            !/^\d+[.)]/.test(text));

        if (headingLike) {
          replaceNode(node, "h3", text.replace(/:+$/, ""));
          activeList = null;
          activeType = null;
          node = next;
          continue;
        }

        const listMatch = text.match(/^([-*•])\s+(.+)$/);
        const orderedMatch = text.match(/^\d+[.)]\s+(.+)$/);

        if (listMatch || orderedMatch) {
          const nextType = orderedMatch ? "ol" : "ul";
          const itemText = (orderedMatch ? orderedMatch[1] : listMatch[2]).trim();

          if (!activeList || activeType !== nextType) {
            activeList = document.createElement(nextType);
            activeList.className =
              nextType === "ol"
                ? "guide-editorial__list guide-editorial__list--ordered"
                : "guide-editorial__list";
            node.before(activeList);
            activeType = nextType;
          }

          const item = document.createElement("li");
          item.textContent = itemText;
          activeList.appendChild(item);
          node.remove();
          node = next;
          continue;
        }
      }

      activeList = null;
      activeType = null;
      node = next;
    }
  }

  function buildToc(root, container) {
    const tocHost = root.querySelector("[data-guide-toc]");
    if (!tocHost) return;

    const headings = Array.from(container.querySelectorAll("h2, h3")).filter(
      (heading) => (heading.textContent || "").trim().length > 0
    );

    if (headings.length < 3) {
      tocHost.hidden = true;
      return;
    }

    const usedIds = new Set();
    const items = headings.map((heading) => {
      let id = heading.id || slugify(heading.textContent);
      while (!id || usedIds.has(id)) {
        id = `${id || "section"}-next`;
      }
      usedIds.add(id);
      heading.id = id;
      return `<li><a href="#${id}">${heading.textContent}</a></li>`;
    });

    tocHost.innerHTML = `
      <p class="guide-editorial__toc-kicker">On this page</p>
      <ul>${items.join("")}</ul>
    `;
    tocHost.hidden = false;
  }

  document.querySelectorAll("[data-guide-editorial-root]").forEach((root) => {
    const container = root.querySelector("[data-guide-article-content]");
    if (!container) return;
    normalizeInlineLists(container);
    buildToc(root, container);
  });
})();
